import { v4 as uuid } from 'uuid';
import { EditSpendRow, UpdateStatus } from '.';
import { TTL_DURATION_SECONDS } from '../../constants';

export class BulkUploadRecord {
    public recordId: string;
    public reportId: string;
    public orderNumber?: string;
    public updateStatus?: UpdateStatus;
    public userInputTime: number;
    public updateTime?: number;
    public lambdaExecutionId?: string;
    public editSpendRecords?: EditSpendRow[];
    public lineNumber: number;
    public ttl: number;
    constructor() {
        this.recordId = uuid();
        this.reportId = '';
        this.userInputTime = 0;
        const timeStamp = Date.now();
        this.ttl = Math.floor(timeStamp / 1000) + TTL_DURATION_SECONDS;
    }
}
